import { render, staticRenderFns } from "./ShopPaymentView.vue?vue&type=template&id=0052ad4a&"
import script from "./ShopPaymentView.vue?vue&type=script&lang=js&"
export * from "./ShopPaymentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports